import {Component} from '@angular/core';
import {WelcomeDialogModel} from './welcome-dialog.model';
import {DialogComponent, DialogService, NotificationType} from '@pes/ui';

@Component({
    selector: 'app-welcome-dialog',
    templateUrl: './welcome-dialog.component.html',
    styleUrls: ['./welcome-dialog.component.scss']
})
export class WelcomeDialogComponent extends DialogComponent<WelcomeDialogModel, string> implements WelcomeDialogModel {

    /**
     * @inheritDoc
     */
    public title: string = 'gui.dialog.confirm.confirm';

    /**
     * @inheritDoc
     */
    public message: string = 'gui.dialog.confirm.r_u_sure';

    /**
     * @inheritDoc
     */
    public type: NotificationType = NotificationType.SECONDARY;

    /**
     * @inheritDoc
     */
    public submitBtnText: string = 'gui.dialog.confirm.submit_btn_text';

    /**
     * Creates a new PesConfirmDialogComponent instance.
     *
     * @param {DialogService} dialogService the reference to the DialogService singleton, injected by angular.
     */
    constructor(dialogService: DialogService) {
        super(dialogService);
    }

    /**
     * @inheritDoc
     */
    public close(): void {
        super.close();
    }

    /**
     * Invoked each time the user clicks on the confirm button.
     */
    protected confirm(): void {
        // we set dialog result as true on click on confirm button,
        // then we can get dialog result from caller code
        this.result = 'ok';
        this.close();
    }
}



// WEBPACK FOOTER //
// ./src/app/component/dialog/welcome-dialog/welcome-dialog.component.ts